<template>
  <div>
    <el-steps :active="active" simple finish-status="success" class="title">
      <el-step title="基本参数设置" icon="el-icon-edit-outline" />
      <el-step title="详细参数设置" icon="el-icon-edit" />
      <el-step
        :title="proDetail.is_synchro_edc ? '表单导出设置' : '数据格式设置'"
        icon="el-icon-setting"
      />
    </el-steps>
  </div>
</template>

<script>
import { getProjectId, getProDetail } from "@/utils/auth";
import { detailPro } from "@/api/platform";
export default {
  name: "TitleSeeting",
  props: {
    active: {
      Number,
      default: 1,
    },
  },
  data() {
    return {
      proId: "",
      proDetail: getProDetail(),
    };
  },
  created() {
    this.proId = getProjectId();
  },
};
</script>

<style scoped>
</style>
